<template>
  <app-modal name="invoice-upload-modal" :title="title" width="60%" :esc-to-close="false" @before-open="beforeOpen" @before-close="beforeClose"  hide-footer>
    <div class="row">
      <div class="container-max-height-scroll-80" :class="{
        'col-lg-6' : errorInvoices.length > 0 && uploadInvoices.length > 0,
        'col-lg-12' : uploadInvoices.length === 0
      }" v-if="errorInvoices.length > 0" >
        <h5 class="text-red"><i class="fal fa-exclamation-circle"></i>{{$t('invoice.errorInvoices')}}: </h5>
        <div class="row" v-if="errorInvoices.length > 0">
          <div class="col-md-12">
            <div class="invoice-list full-height">
              <div v-for="(invoice, index) in errorInvoices" track-by="$index" @click="onClickErrorInvoice(invoice, index)"  class="invoice-item">
                <div class="d-flex">
                  <div>
                    <div class="invoice-title">{{index + 1}} - {{invoice.file_name}}</div>
                    <div class="invoice-description red">{{invoice.error}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="uploadInvoices.length > 0"
           class="container-max-height-scroll-80"
           :class="{
            'col-lg-6' : errorInvoices.length > 0 && uploadInvoices.length > 0,
            'col-lg-12' : errorInvoices.length === 0
          }">
        <h5 class="text-green"><i class="fal fa-check"></i>{{$t('invoice.validInvoices')}}: </h5>
        <div class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="uploadInvoices"
              @on-click="onClickInvoice"
            ></invoice-list>
          </div>
        </div>
      </div>
    </div>

  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import InvoiceForm from '@/portal-components/invoice/invoice-form';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import { mapActions } from 'vuex';

export default {
  name: 'InvoiceUploadModal',
  components: {
    InvoiceForm,
    AppModal,
    InvoiceList,
  },
  data() {
    return {
      title: this.$t('invoice.uploadInvoice'),
      uploadInvoices: [],
      errorInvoices: [],
      invoiceList: [],
      activeInvoice: {},
    };
  },
  computed: {},
  created() {
    this.$bus.on('update-invoice-success', this.onUpdateInvoiceSuccess);
  },
  beforeDestroy() {
    this.$bus.off('update-invoice-success', this.onUpdateInvoiceSuccess);
  },
  methods: {
    ...mapActions(['addErrorInvoices']),
    onClickErrorInvoice(errorInvoice, index) {
      this.$nextTick(() => {
        this.$modal.show('invoice-form-modal', {
          invoiceList: this.errorInvoices,
          currentIndex: index,
        });
      });
    },
    onUpdateInvoiceSuccess(payload) {
      if (!payload || !payload.model || !payload.model.id) {
        return;
      }
      this.errorInvoices = this.errorInvoices.filter(inv => inv.id !== payload.model.id);
      this.uploadInvoices = this.uploadInvoices.filter(inv => inv.id !== payload.model.id);
      if (this.uploadInvoices.length === 0 && this.errorInvoices.length === 0) {
        this.$modal.hide('invoice-upload-modal', { isOk: true });
      }
    },
    onClickInvoice(invoice, index) {
      this.activeInvoice = invoice;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$modal.show('invoice-form-modal', {
            invoiceList: this.uploadInvoices,
            currentIndex: index,
          });
        });
      });
    },
    beforeOpen(params) {
      this.uploadInvoices = params.model.invoices;
      this.errorInvoices = params.model.invoices_error;
      const errorInvoices = {};
      this.errorInvoices.forEach((errorInv) => {
        errorInvoices[errorInv.id] = errorInv.error;
      });
      this.addErrorInvoices(errorInvoices);
      this.invoiceList = [
        ...this.errorInvoices,
        ...this.uploadInvoices,
      ];
    },
    beforeClose() {
      this.$bus.emit('close-invoice-upload-modal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-upload-modal.vue